import "./AdviserRiskRowComponent.scss";
import {AdviserViewRow} from "../../../models/view-model/RiskDashboardViewModel";
import {RiskDashboardViewStore} from "../../../store/RiskDashboardViewStore";
import {RiskRowEntityType} from "../../../models/RiskRowEntityType";

export const AdviserRiskRow = "adviserRiskRow";

export function adviserRiskRow() {
    return {
        templateUrl: "app/risk/dashboard/components/grid/adviser/AdviserRiskRowComponent.html",
        bindings: {
            adviser: "<",
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: AdviserRiskRowComponentController
    };
}

export class AdviserRiskRowComponentController {
    public readonly adviser: AdviserViewRow;
    public readonly viewStore: RiskDashboardViewStore;

    public toggleCollapse() {
        this.viewStore.toggleCollapse(RiskRowEntityType.ADVISER, this.adviser.entity.id);
    }
}
